/**
 * Constantes del feature de envíos
 */
import { BADGE_COLORS } from '../../components/ui/badgeColors';

// Tamaño máximo de observaciones/comentarios
export const TAM_MAX_OBSERVACIONES = 2000;

// Estados de envío
export const ENVIO_ESTADO = {
    ENTREGADO: '-1',
    PENDIENTE: '0',
};

// Días por defecto para filtro de fecha inicio
export const DIAS_ATRAS_DEFAULT = 15;

// Fondo de los envíos a cliente final (clienteFinal del backend: cliente de contado).
// DECISION: morado de la paleta porque no es un estado; el color del tracking ya va en
// el borde de la tarjeta y en el chip, y no debe confundirse con él
export const FONDO_CLIENTE_FINAL = BADGE_COLORS.PURPLE.bg;
export const FONDO_CLIENTE_FINAL_HOVER = '#ead6ee';

// Clase de fila del DataGrid para los envíos a cliente final
export const CLASE_FILA_CLIENTE_FINAL = 'fila-cliente-final';
